import { makeStyles } from "@mui/styles";
import { COLORS } from "components/v3/Theme/colors";

const LinkBoxGridStyles = makeStyles((theme) => ({
  container: {
    padding: "0 55px 50px 55px",
    margin: "0px 0 40px"
  },
  linkBoxContainer: {
    display: "flex"
  },

  headerContainer: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "1.25rem",
    "@media (max-width: 700px)": {
      display: "block",
      justifyContent: "initial"
    }
  },
  linkBox: {
    width: "95%",
    paddingBottom: "1rem",
    marginBottom: "1rem",
    lineHeight: "1.5rem"
  },
  header: {
    marginBottom: 15
  },
  headline: {
    textAlign: "left"
  },
  linkHeader: {
    fontWeight: 600
  },
  summary: {
    color: COLORS.BLACK,
    fontWeight: 400,
    display: "block",
    fontSize: "1rem",
    lineHeight: "1.5rem"
  },
  link: {
    color: COLORS.DARK_GRAY_2,
    fontWeight: 600,
    marginBottom: ".25rem"
  },
  linkContainer: {
    color: COLORS.ACCENT2,
    textDecoration: "underline",
    fontWeight: 600
  }
}));

export default LinkBoxGridStyles;
